import { createIntl, createIntlCache } from "react-intl";

import messagesTurkish from "./translations/tr";
import messagesRussia from "./translations/ru";
import messagesArabic from "./translations/ar";

import { store } from "./store";
import { resolveLanguage } from "./utils/language";

let cache;
let intl;

const generateIntl = () => {
  if (cache) {
    cache = null;
  }

  const userLanguage = store.getState().user.userLanguage;

  cache = createIntlCache();

  const messages = {
    // 'en' : messagesEnglish,
    tr: messagesTurkish,
    ru: messagesRussia,
    ar: messagesArabic,
  };

  const locale = resolveLanguage(userLanguage);

  intl = createIntl({ locale, messages: messages[locale] }, cache);
  return intl;
};

export { generateIntl, intl };
